
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface AuditLog {
  id: string;
  created_at: string;
  test_response_id: string;
  test_id: string;
  changed_by: string;
  action: string;
  field_name: string;
  old_value: string | null;
  new_value: string | null;
  metadata: Record<string, any>;
  changer_profile: {
    full_name: string;
    email: string;
  };
}

export function useAuditLogs(testResponseId: string) {
  return useQuery({
    queryKey: ['audit-logs', testResponseId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('response_audit_logs')
        .select(`
          *,
          changer_profile:changed_by (
            full_name,
            email
          )
        `)
        .eq('test_response_id', testResponseId)
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data as AuditLog[];
    },
    enabled: !!testResponseId,
  });
}
